import { Button, Input, Modal, Tabs, Popover } from 'ant-design-vue' // Import specific components
import throttle from 'lodash/throttle' // Import the throttle function
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import VueHead from 'vue-head'
import VueLazyload from 'vue-lazyload'
import Meta from 'vue-meta'
import App from './App.vue'
import axios from './axios'
import i18n from './i18n'
import marked from './marked'
import router from './router'

Vue.config.productionTip = false

// Use specific Ant Design components
Vue.use(Button)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Tabs)
Vue.use(Popover)

Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)
Vue.prototype.$axios = axios
Vue.prototype.$md = marked
Vue.prototype.$assets = process.env.VUE_APP_DIRECTUS_ASSETS

Vue.use(VueHead)
Vue.use(Meta, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid',
    refreshOnceOnNavigation: true
})

Vue.use(VueLazyload, {
    preLoad: 1.3,
    lazyComponent: true,
    // attempt: 1,
})

router.beforeEach((to, from, next) => {
    const { lang } = to.query
    if (lang && (lang === 'zh' || lang === 'en')) {
        i18n.locale = lang
        // Remove the lang parameter from the URL
        const newQuery = { ...to.query }
        delete newQuery.lang
        next({ ...to, query: newQuery })
    } else {
        next()
    }
})


new Vue({
    router,
    i18n,
    data: {
        countries: [],
        productTags: []
    },
    async mounted() {
        this.$nextTick(() => {
            this.rem()
        })
        window.addEventListener('resize', this.throttledRem)

        await this.fetchData()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.throttledRem)
    },
    methods: {
        rem() {
            const { clientWidth } = document.documentElement
            document.documentElement.style.fontSize = `${clientWidth / (clientWidth > 768 ? 1680 : 375)}px`
        },
        throttledRem: throttle(function () {
            this.rem()
        }, 200),
        async fetchData() {
            try {
                const [productResponse, countryResponse] = await Promise.all([
                    this.$axios.get('/product_category', {
                        params: {
                            fields: '*,translations.*',
                            'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                            // sort: 'date_created',
                            'filter[status][_eq]': 'published'
                        }
                    }),
                    this.$axios.get('/country', {
                        params: {
                            fields: '*,translations.*',
                            'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                            // sort: 'date_created',
                            'filter[status][_eq]': 'published'
                        }
                    })
                ])
                this.productTags = productResponse.data.data
                this.countries = countryResponse.data.data
            } catch (error) {
                console.error('Error fetching term data:', error)
            }
        }
    },
    render: h => h(App)
}).$mount('#app')
